// extracted by mini-css-extract-plugin
export default {"display":"Table_display__uVE8I","topRowData":"Table_topRowData__f9G5u","borderdata":"Table_borderdata__yZxvh"};